import { Link } from 'react-router-dom';

interface Event {
    id: string;
    name: string;
    date: string;
    location: string;
    games: string[];
    results: {
        game: string;
        placement: string;
        players?: string[];
    }[];
}

const events: Event[] = [
    {
        id: 'state-finals-fall-2025',
        name: 'MIHSEF State Finals',
        date: 'December 2025',
        location: 'University of Michigan - Flint',
        games: ['SSBU Solos', 'SSBU Crews', 'Mario Kart 8'],
        results: [
            {
                game: 'SSBU Crews',
                placement: '2nd Place',
                players: ['PandaMan22 (C)', 'Taco', 'Beasty5932']
            },
            {
                game: 'SSBU Solos',
                placement: '3rd Place',
                players: ['PandaMan22']
            },
            {
                game: 'Mario Kart 8',
                placement: '14th Place'
            },
        ],
    },
    {
        id: 'confluence-festival-2025',
        name: 'Confluence Festival',
        date: 'Fall 2025',
        location: 'Grand Rapids, MI',
        games: ['SSBU'],
        results: [], // TBD - awaiting data
    },
    {
        id: 'river-city-invitational-2025',
        name: 'River City Invitational',
        date: 'Fall 2025',
        location: 'Comic Con - Grand Rapids, MI',
        games: ['SSBU Crews'],
        results: [
            {
                game: 'SSBU Crews',
                placement: '4th Place',
            },
        ],
    },
];

export default function ChampionshipsPage() {
    return (
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            {/* Header */}
            <div className="text-center mb-12 animate-fade-in">
                <h1 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">
                    🏆 <span className="text-primary-500">Championships</span>
                </h1>
                <p className="text-secondary-400 text-lg">Peck Pirates Tournament Results</p>
            </div>

            {/* Events */}
            <div className="space-y-8">
                {events.map((event, idx) => (
                    <section
                        key={event.id}
                        className="card animate-slide-up"
                        style={{ animationDelay: `${idx * 0.1}s` }}
                    >
                        <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
                            <div>
                                <h2 className="text-2xl font-display font-bold text-white">{event.name}</h2>
                                <p className="text-secondary-400">{event.date} • {event.location}</p>
                            </div>
                            <div className="flex flex-wrap gap-2">
                                {event.games.map(g => (
                                    <span key={g} className="badge bg-secondary-700 text-secondary-300">{g}</span>
                                ))}
                            </div>
                        </div>

                        {event.results.length > 0 ? (
                            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {event.results.map((result, i) => (
                                    <div
                                        key={i}
                                        className={`p-4 rounded-lg border ${result.placement.includes('1st') || result.placement.includes('2nd') || result.placement.includes('3rd')
                                            ? 'border-primary-500/50 bg-primary-500/5'
                                            : 'border-secondary-700 bg-secondary-800/50'
                                            }`}
                                    >
                                        <div className="flex items-center justify-between mb-2">
                                            <h3 className="font-semibold text-white">{result.game}</h3>
                                            <span className={`px-2 py-0.5 rounded text-sm font-medium ${result.placement.includes('1st') ? 'bg-yellow-500/20 text-yellow-400' :
                                                result.placement.includes('2nd') ? 'bg-gray-400/20 text-gray-300' :
                                                    result.placement.includes('3rd') ? 'bg-orange-500/20 text-orange-400' :
                                                        'bg-secondary-700 text-secondary-300'
                                                }`}>
                                                {result.placement}
                                            </span>
                                        </div>
                                        {result.players && (
                                            <div className="flex flex-wrap gap-1 mt-2">
                                                {result.players.map((p, j) => (
                                                    <span key={j} className="text-sm text-secondary-400">{p}{j < result.players!.length - 1 && ', '}</span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-8 text-secondary-500">
                                <p>📋 Results coming soon</p>
                            </div>
                        )}
                    </section>
                ))}
            </div>

            {/* Contact */}
            <div className="mt-12 text-center">
                <p className="text-secondary-500">
                    Questions? Contact Coach Brian Anklam<br />
                    <a href="mailto:anklamb@peckschools.net" className="text-primary-400 hover:underline">anklamb@peckschools.net</a>
                    {' • '}
                    <a href="tel:8103780645" className="text-primary-400 hover:underline">(810) 378-0645</a>
                </p>
            </div>

            {/* Nav */}
            <div className="flex justify-center gap-4 mt-8">
                <Link to="/records" className="btn-primary">View Player Records →</Link>
            </div>
        </div>
    );
}
